import { Button } from 'react-bootstrap'
import { BsXCircleFill } from 'react-icons/bs'

const ServicesDesktop = ({ serviceLines = {} }) => {
	return (
		<div className='pb-3'>
			<span className='d-block fs-small'>Service</span>
			<div className='d-grid grid-auto-columns grid-template-areas-3 grid-gap-2'>

				{Object.keys(serviceLines).map((key, index) => {
					return (
						<div key={key} className='border rounded p-2 d-flex  fs-sub mt-2'>
							<div className='pe-3'>
								<div className='fw-600'>{serviceLines[key]}</div>
							</div>
							{/* <div className='flex-grow-1 ms-2 text-end'>
								{serviceLines[key]}
							</div> */}
						</div>
					)
				})}
			</div>
			{/* <div className='pt-3'>
				<Button
					variant='default'
					className='d-flex ms-auto p-0 text-light fs-sub text-uppercase align-items-center'
				>
					don’t work on this vehicle
					<BsXCircleFill size={16} />
				</Button>
			</div> */}
		</div>
	)
}

export default ServicesDesktop
